/* eslint-disable max-len */
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('product-reviews')
class ProductReviews extends LitElement {
  @property({ type: Number, attribute: 'product-id' })
  accessor productId;

  @property({ type: String, attribute: 'yotpo-api-key' })
  accessor yotpoApiKey;

  @property({ type: Number, attribute: 'review-count' })
  accessor reviewCount;

  @property({ type: Number, attribute: 'average-score' })
  accessor averageScore;

  @property({ type: Boolean, attribute: 'has-half-star' })
  accessor hasHalfStar;

  @property({ type: Number, attribute: 'empty-stars' })
  accessor emptyStars;

  @property({ type: Number, attribute: 'full-stars' })
  accessor fullStars;

  static styles = css`
    span {
      font-size: 0.75rem;
      line-height: 1.6;
      letter-spacing: 0.1px;
      text-decoration-line: underline;
      cursor: pointer;
      --tw-text-opacity: 1;
      color: rgba(66, 62, 59, var(--tw-text-opacity, 1));
    }
    div {
      display: flex;
      gap: 2px;
      cursor: pointer;
    }
    svg.text-gray-500 {
      color: #aba9a8;
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    this.fetchReviewCount();
  }

  fetchReviewCount = async () => {
    if (!this.yotpoApiKey) return;
    // eslint-disable-next-line max-len
    const baseUrl = `https://api.yotpo.com/products/${this.yotpoApiKey}/${this.productId}/bottomline`;
    const response = await fetch(baseUrl);
    const json = await response.json();
    this.averageScore = json?.response?.bottomline?.average_score || 0;
    this.emptyStars = 5 - this.averageScore;
    this.hasHalfStar = this.averageScore % 1 !== 0;
    this.fullStars = this.hasHalfStar
      ? 5 - this.emptyStars - 1
      : 5 - this.emptyStars;
    this.reviewCount = json.response.bottomline.total_reviews;
  };

  render() {
    const iconStar = html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
      >
        <path
          fill="currentColor"
          d="M8 0l1.88 5.411 5.728.117-4.565 3.46 1.66 5.484L8 11.2l-4.702 3.272L4.957 8.99.392 5.528l5.727-.117L8 0z"
        ></path>
      </svg>
    `;

    const iconStarHalf = html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="15"
        viewBox="0 0 16 15"
        class="text-text-default"
        fill="none"
      >
        <path
          d="M8 0L9.88091 5.41115L15.6085 5.52786L11.0434 8.98885L12.7023 14.4721L8 11.2L3.29772 14.4721L4.95662 8.98885L0.391548 5.52786L6.11909 5.41115L8 0Z"
          fill="currentColor"
        ></path>
        <mask
          id="mask0_2205_11001"
          maskUnits="userSpaceOnUse"
          x="8"
          y="0"
          width="8"
          height="16"
          style="mask-type: alpha;"
        >
          <rect
            width="8"
            height="16"
            transform="matrix(-1 0 0 1 16 0)"
            fill="currentColor"
          ></rect>
        </mask>
        <g mask="url(#mask0_2205_11001)">
          <path
            d="M8 0L6.11909 5.41115L0.391548 5.52786L4.95662 8.98885L3.29772 14.4721L8 11.2L12.7023 14.4721L11.0434 8.98885L15.6085 5.52786L9.88091 5.41115L8 0Z"
            fill="#ABA9A8"
          ></path>
        </g>
      </svg>
    `;

    const iconStarEmpty = html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="15"
        viewBox="0 0 16 15"
        class="text-gray-500"
        fill="none"
      >
        <path
          fill="currentColor"
          d="M8 0l1.88 5.411 5.728.117-4.565 3.46 1.66 5.484L8 11.2l-4.702 3.272L4.957 8.99.392 5.528l5.727-.117L8 0z"
        ></path>
      </svg>
    `;

    return html`
      <div class="flex gap-0.5 cursor-pointer">
        ${this.fullStars > 0
          ? [...Array(this.fullStars).keys()].map(() => iconStar)
          : ''}
        ${this.hasHalfStar ? iconStarHalf : ''}
        ${this.emptyStars > 0
          ? [...Array(this.emptyStars).keys()].map(() => iconStarEmpty)
          : ''}
      </div>
      <span class="body-3--underline text-text-subdued cursor-pointer">
        (${this.reviewCount} Reviews)
      </span>
    `;
  }
}

export default ProductReviews;
